export default __webpack_public_path__ + "static/media/fullscreen.3c7dd415.svg";